// I know that the code could be better.
// If you have some tips or improvement, please let me know.

$('.parallax-horizontal').each(function(){
    var img = $(this);
    var imgParent = $(this).parent();
    function parallaxHorizontalImg () {
        var speed = img.data('speed');
        var imgY = imgParent.offset().top;
        var winY = $(this).scrollTop();
        var winH = $(this).height();
        var parentH = imgParent.innerHeight();


        // The next pixel to show on screen
        var winBottom = winY + winH;

        // If block is shown on screen
        if (winBottom > imgY && winY < imgY + parentH) {
            // Number of pixels shown after block appear
            var imgBottom = ((winBottom - imgY) * speed);
            // Max number of pixels until block disappear
            var imgTop = winH + parentH;
            // Porcentage between start showing until disappearing
            var imgPercent = ((imgBottom / imgTop) * 100) + (50 - (speed * 50));
        }
        img.css({
            left: imgPercent + '%',
            transform: 'translate(' + imgPercent + '%, 0)'
        });
    }
    
        $(document).on({
            scroll: function () {
                parallaxHorizontalImg();
            }, ready: function () {
                parallaxHorizontalImg();
            }
        });
});
